import { debounce } from 'lodash'

export default {
  props: ['attribute', 'editName'],
  data () {
    return {
      content: this.attribute.value,
      name: this.attribute.name,
      renameEventOccurrence: 0
    }
  },
  methods: {
    rename (event) {
      if (this.name === '') {
        this.name = this.attribute.name
        this.shakeElement(this.$refs.name)
        return
      }
      if (this.renameEventOccurrence > 0) return
      this.renameEventOccurrence++
      if (event.type !== 'blur') {
        this.$refs.name.blur()
      }
      this.$emit('cancel-edit')
      if (this.attribute.name !== this.name) {
        this.$emit('rename', this.name)
      }
    }
  },
  watch: {
    content: debounce(function () {
      this.$emit('update', this.content)
    }, 500),
    attribute (newValue) {
      this.content = newValue.value
      this.name = newValue.name
    },
    editName (newValue, oldValue) {
      if (newValue && !oldValue) {
        this.renameEventOccurrence = 0
        this.$refs.name.focus()
      }
    }
  }
}
